/**
 * Keeps a newsletter form's submit button disabled until the email looks valid,
 * then switches it to the active (black) button. From the design team's button
 * states spec (ClickUp 14zcqntjbqb): the button "starts at disabled and becomes
 * active once you input your email".
 *
 * Without JavaScript nothing is disabled, and the input's own `required` /
 * type="email" check still runs on submit. snippets/newsletter-form.liquid loads
 * this once per form, so it guards against binding twice.
 *
 * newsletter-autosignup.js fills the field from an ?email= link and fires
 * `input`, so a prefilled form enables itself before that script submits it.
 */
(function () {
  if (window.__newsletterSubmitState) return;
  window.__newsletterSubmitState = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function sync(form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!input || !button) return;
    button.disabled = !EMAIL.test(input.value.trim());
  }

  function bind(root) {
    root.querySelectorAll('form.newsletter-form').forEach(function (form) {
      if (form.dataset.submitStateBound) return;
      form.dataset.submitStateBound = 'true';
      sync(form);
      // `focusin` catches browser autofill that lands without an input event.
      ['input', 'change', 'focusin'].forEach(function (type) {
        form.addEventListener(type, function () { sync(form); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  // Sections re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
